var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile2Dm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.041,
    viewBox: "0 0 40 48.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_573",
    "data-name": "Trac\\xE9 573",
    d: "M95.429,95.236h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.436.059,14.748,0,17.6-.028,3.556-.038,3.623-.038,4.274.612.408.407,5.136,6.359,6.05,7.514,6.063,7.662,6.063,7.753,6.063,8.623V89.236A6.007,6.007,0,0,1,95.429,95.236Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V64.53C95.97,62.49,89,53.7,86.937,51.192c-.461,0-1.112.008-1.853.016C82.22,51.238,76.889,51.295,67.424,51.236Z",
    transform: "translate(-61.429 -47.195)",
    fill: "#d7d9ea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile2Dm);
export default __webpack_public_path__ + "static/media/file2DM.48787bdac5d74a9a73c80e8ab9d49dd2.svg";
export { ForwardRef as ReactComponent };